import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { PortalSelectMenu } from 'components/FormControls';
import { IDropdownData } from 'models/common';
import { Button } from 'components';

require('./style.scss');

interface IProps {
	/* left filter */
	leftFilterKey?: string;
	leftFilterOptions?: IDropdownData[];
	leftFilterTitle?: string;
	onLeftFilterChange?: (value: string) => void;

	/* right filter */
	rightFilterKey?: string;
	rightFilterOptions?: IDropdownData[];
	rightFilterTitle?: string;
	onRightFilterChange?: (value: number) => void;

	/* search */
	searchKeyword?: string;
	onSearchButtonClick?: () => void;
	onSearchEnterPress?: () => void;
	onSearchValueChange?: (value: string) => void;

	/* save button */
	saveButtonText?: string;
	onSaveButtonClick?: () => void;

	t?: (key: string) => string;
}

interface IState {
	hasSearched: boolean;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class FilterBar extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			hasSearched: false,
		};

		this.handleLeftFilterChange = this.handleLeftFilterChange.bind(this);
		this.handleRightFilterChange = this.handleRightFilterChange.bind(this);
		this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
		this.handleSearchEnterPress = this.handleSearchEnterPress.bind(this);
		this.handleOnSaveButtonClick = this.handleOnSaveButtonClick.bind(this);
		this.handleSearchButtonClick = this.handleSearchButtonClick.bind(this);
	}

	componentDidUpdate(prevProps: Readonly<IProps>): void {
		// Reset search when emptying input
		if (this.state.hasSearched && prevProps?.searchKeyword?.length && !this.props?.searchKeyword?.length) {
			this.props.onSearchButtonClick();
			this.setState({ hasSearched: false });
		}
	}

	public handleLeftFilterChange(val: string) {
		this.props.onLeftFilterChange(val);
	}

	public handleRightFilterChange(val: string) {
		this.props.onRightFilterChange(parseInt(val, 10));
	}

	private handleSearchValueChange(e: any) {
		const value: string = e.target.value;
		this.props.onSearchValueChange(value.length > 0 ? value : '');
	}

	private handleSearchButtonClick() {
		this.props.onSearchButtonClick();
		this.setState({ hasSearched: true });
	}

	private handleSearchEnterPress(event: any) {
		if (event.key === 'Enter') {
			this.props.onSearchEnterPress();
			this.setState({ hasSearched: true });
		}
	}

	private handleOnSaveButtonClick() {
		if (this.props.onSaveButtonClick) {
			this.props.onSaveButtonClick();
		}
	}

	public render() {
		const {
			t,
			searchKeyword,
			leftFilterKey,
			leftFilterOptions,
			leftFilterTitle,
			rightFilterOptions,
			rightFilterKey,
			rightFilterTitle,
			saveButtonText,
			onSaveButtonClick,
			onSearchEnterPress,
			onSearchButtonClick,
			onSearchValueChange,
		} = this.props;

		let searchFilter: string = searchKeyword;
		if (!searchFilter) {
			searchFilter = '';
		}

		const leftFilterDropDownInputProps: object = {
			id: 'leftFilter',
			onChange: this.handleLeftFilterChange,
			value: leftFilterKey,
			name: 'leftFilter',
		};

		const rightFilterDropDownInputProps: object = {
			id: 'rightFilter',
			onChange: this.handleRightFilterChange,
			value: rightFilterKey,
			name: 'rightFilter',
		};

		let leftFilterDropdown = null;
		if (leftFilterOptions && leftFilterOptions.length > 0 && leftFilterTitle && leftFilterTitle.length > 0) {
			leftFilterDropdown = [
				<div key="leftFilterTitleKey" className="text">
					{leftFilterTitle}
				</div>,
				<PortalSelectMenu
					usage="admin"
					key="leftFilterDropdownKey"
					input={leftFilterDropDownInputProps}
					items={leftFilterOptions}
					searchable={false}
				/>,
			];
		}

		let rightFilterDropdown = null;
		if (rightFilterOptions && rightFilterOptions.length > 0 && rightFilterTitle && rightFilterTitle.length > 0) {
			let classes = 'fieldHolder';
			if (
				(onSearchEnterPress && onSearchButtonClick && onSearchValueChange) ||
				(onSaveButtonClick && saveButtonText && saveButtonText.length > 0)
			) {
				classes = `fieldHolder hasNeighbour`; // there are filter and search/save button
			}

			rightFilterDropdown = (
				<div className={classes}>
					<div key="rightFilterTitleKey" className="text">
						{rightFilterTitle}
					</div>
					<PortalSelectMenu
						usage="admin"
						key="rightFilterDropdownKey"
						input={rightFilterDropDownInputProps}
						items={rightFilterOptions}
						isRequired={true}
						searchable={false}
					/>
				</div>
			);
		}

		let mostRightContent = null;
		// render search field on most right
		if (onSearchEnterPress && onSearchButtonClick && onSearchValueChange) {
			mostRightContent = (
				<div className="fieldHolder">
					<div key="searchFilterTitleKey" className="text">
						{t('BSPortal_Common_Filter_Search')}
					</div>
					<div key="searchFilterFieldKey" className="inputHolder">
						<input
							type="text"
							name="searchPortalPages"
							value={searchFilter}
							onKeyUp={(e) => {
								this.handleSearchEnterPress(e);
							}}
							onChange={this.handleSearchValueChange}
							placeholder={t('BSPortal_Common_Search')}
						/>
						<button onClick={this.handleSearchButtonClick}>
							<img src={require('containers/Html/icons/search_black.svg')} className="icon" />
						</button>
					</div>
				</div>
			);
		} else if (onSaveButtonClick && saveButtonText && saveButtonText.length > 0) {
			// render save button on most right
			mostRightContent = (
				<div className="fieldHolder">
					<Button
						key="filterbarSaveButtonKey"
						usage="admin"
						onClick={this.handleOnSaveButtonClick}
						disabled={leftFilterKey ? false : true}
					>
						{saveButtonText}
					</Button>
				</div>
			);
		}

		return (
			<div className="adminFilterBar">
				<div className="leftContent">
					<div className="fieldHolder">{leftFilterDropdown}</div>
					<div className="fieldHolder">{rightFilterDropdown}</div>
				</div>
				<div className="rightContent">{mostRightContent}</div>
			</div>
		);
	}
}
export { FilterBar };
